

import Admin, { hasRole, Role } from '@/models/Admin'
import Credit from '@/models/Credit'

export default class CreditPolicy {
    viewAny(_admin: Admin): boolean {
        return true
    }

    view(admin: Admin, credit: Credit) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER,Role.STATION_MANAGER])
    }

    create(admin: Admin) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.COUNTRY_MANAGER])
    }

    update(admin: Admin, credit: Credit) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    restore(admin: Admin, credit: Credit) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    delete(admin: Admin, credit: Credit) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    forceDelete(_admin: Admin, _credit: Credit) {
        return false
    }
}
